import React, { useMemo } from "react";
import { SubmissionError } from "redux-form";

import { Loader } from "@braintrust/braintrust-ui-components";
import { fetchCurrentUser } from "@js/apps/auth/actions";
import { useUpdateEmployerInfoMutation } from "@js/apps/employer/api";
import {
  useEmployerId,
  useGetManagedEmployerQuery,
} from "@js/apps/employer/hooks";
import { useAppDispatch } from "@js/hooks";
import { getFormSubmitError } from "@js/utils/redux-form";

import type { VisibilityFormValues } from "../../forms/visibility";
import { VisibilityForm } from "../../forms/visibility";

export const EmployerVisibility = () => {
  const employerId = useEmployerId();
  const dispatch = useAppDispatch();

  const { data: employerProfile, isLoading: isLoadingEmployerProfile } =
    useGetManagedEmployerQuery();
  const [updateEmployerInfo] = useUpdateEmployerInfoMutation();

  const onSubmit = async (
    values: Pick<VisibilityFormValues, "show_number_of_jobs">,
  ) => {
    if (!employerId) {
      return;
    }

    try {
      await updateEmployerInfo({
        employerId,
        newData: values,
      }).unwrap();

      dispatch(fetchCurrentUser()).catch(() => null);
    } catch (err: unknown) {
      const e = getFormSubmitError(err);
      throw new SubmissionError(e?.data as object);
    }
  };

  const initialValues = useMemo(() => {
    return {
      show_number_of_jobs: employerProfile?.show_number_of_jobs,
    };
  }, [employerProfile]);

  if (!employerProfile || isLoadingEmployerProfile) {
    return <Loader centered />;
  }

  return (
    <VisibilityForm
      onSubmit={onSubmit}
      initialValues={initialValues}
      accountType={ENUMS.AccountType.EMPLOYER}
    />
  );
};
